module.exports = __webpack_public_path__ + "static/media/readyassetpro.4350e738.png";